export * from './ch-pager.component';
export * from './ch-pager.module';
